<template>
	<div></div>
</template>

<script>
	export default {
	  name: 'Home'
	}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue